import { Button } from '@steelwake/ui';
import { useEffect, useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router';

import { api, describeError } from '../api.js';
import { Card, Field, Notice, PageTitle } from '../ui.js';

export function ResetPassword() {
  const [params] = useSearchParams();
  // Read once, then dropped from the address bar and history (see VerifyEmail).
  const [token] = useState(() => params.get('token') ?? '');
  useEffect(() => {
    if (window.location.search) window.history.replaceState(null, '', window.location.pathname);
  }, []);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password !== confirm) {
      setError('The two passwords do not match.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api('/api/v1/auth/reset-password', { method: 'POST', body: { token, password } });
      setDone(true);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card>
      <PageTitle>Choose a new password</PageTitle>
      {done ? (
        <>
          <Notice kind="success" testId="reset-success">
            Your password has been changed. Every other session was signed out.
          </Notice>
          <p>
            <Link to="/login">Log in with your new password</Link>
          </p>
        </>
      ) : (
        <form onSubmit={submit} noValidate>
          <Field
            label="New password"
            name="password"
            type="password"
            autoComplete="new-password"
            required
            hint="At least 10 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Field
            label="Confirm new password"
            name="confirm"
            type="password"
            autoComplete="new-password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          {error ? (
            <Notice kind="error" testId="form-error">
              {error}
            </Notice>
          ) : null}
          <Button type="submit" disabled={busy || token.length === 0}>
            {busy ? 'Saving…' : 'Set password'}
          </Button>
        </form>
      )}
    </Card>
  );
}
